const i18nService = {
  defaultLanguage: "fr_FR",

  languages: [
    {
      lang: "en_GB",
      name: "English",
      flag: process.env.BASE_URL + "media/svg/flags/226-united-states.svg"
    },

    {
      lang: "fr_FR",
      name: "Français",
      flag: process.env.BASE_URL + "media/svg/flags/019-france.svg"
    }
  ],

  /**
   * Keep the active language in the localStorage
   * @param lang
   */
  setActiveLanguage(lang) {
    localStorage.setItem("language", lang);
  },

  /**
   * Get the current active language
   * @returns {string | string}
   */
  getActiveLanguage() {
    return localStorage.getItem("language") || this.defaultLanguage;
  }
};

export default i18nService;
